import { Navigate, useParams } from 'react-router-dom'
import { useAppointmentManageTarget } from 'src/modules/booking/hooks'
import { Loader } from 'src/modules/core/components'
import { routeNames } from 'src/modules/core/constants/routeNames'

/**
 * Landing page for the "Manage your appointment" link sent to clients
 * (/appointments/:bookingId). The link is minted before the calendar event
 * exists, so the richest available surface is resolved at click time and this
 * page forwards to it.
 *
 * Anything other than a resolved confirmation target lands on the booking
 * details page, which renders the expired/cancelled state on its own.
 */
export function AppointmentManage() {
  const { bookingId } = useParams<{ bookingId: string }>()
  const manageTarget = useAppointmentManageTarget(bookingId ?? '')

  if (!bookingId) return <Navigate to={routeNames.home.path} replace />

  if (manageTarget.isLoading) return <Loader isLoading full />

  const target = manageTarget.isError ? undefined : manageTarget.data
  if (target?.target === 'confirmation') {
    return <Navigate to={`${routeNames.confirmation.path}/${target.urlCode}`} replace />
  }

  return <Navigate to={routeNames.bookingDetails.path.replace(':bookingId', bookingId)} replace />
}
